export default "__VITE_ASSET__CgSDUznM__"